export enum RtbObjective {
  AWARENESS = 'AWARENESS',
  TRAFFIC = 'TRAFFIC',
  SALES = 'SALES',
  // legacy objectives
  REACH = 'REACH',
  LINK_CLICKS = 'LINK_CLICKS'
}
